import { StyleSheet } from 'aphrodite/no-important';
import { media } from 'util/style-helpers';

interface IAgreementFormStyleProps {
  hasCustomOptions?: boolean;
}

export const style: any = (props: IAgreementFormStyleProps) => {
  return StyleSheet.create({
    commentForm: {
      width: '100%',
      [media.smallerThanTablet]: {
        paddingTop: '25px',
      },
    },
    headline: {
      width: '100vw',
      margin: `0px calc((100% - 100vw)/2)`,
      [media.tablet]: {
        width: '100vw',
        margin: `0px calc((-100vw + 100%)/2) 25px`,
      },
      [media.desktop]: {
        width: '100%',
        margin: '0px 0px 25px 0px ',
      },
      padding: '30px',
      borderTop: '1px solid red',
      borderBottom: '1px solid red',
      fontSize: 24,
      fontWeight: 'bold',
      marginBottom: 20,
      [media.smallerThanTablet]: {
        padding: '20px 0',
        textAlign: 'center',
      },
    },
    commentBox: {
      backgroundColor: 'transparent',
      border: '1px solid white',
      borderRadius: 5,
      width: '100%',
      lineHeight: `${20 / 16}`,
      fontSize: 16,
      color: 'white',
      padding: 30,
    },
  });
};
